import styled from 'styled-components';

import { EActionAttribute, EFontWeight, WithThemeProps } from '@core/type';

import { BoxProps } from '../interface';
import { Box } from '../layout/Box';
import { ListProps } from './interface-list';

export const List = ({ as, children, markerFontWeight, ...props }: ListProps & BoxProps) => {
  return (
    <StyledListContainer {...props} markerFontWeight={markerFontWeight}>
      <Box as={as}>{children}</Box>
    </StyledListContainer>
  );
};

const StyledListContainer = styled(Box)<BoxProps & ListProps>(
  ({
    theme: {
      typography: { fontWeight },
    },
    markerFontWeight = EFontWeight.REGULAR,
    gap = '8px',
  }: BoxProps & ListProps & WithThemeProps) => ({
    [`${EActionAttribute.UL},
      ${EActionAttribute.OL}`]: {
      paddingLeft: '18px',

      [EActionAttribute.LI]: {
        paddingLeft: '8px',
        marginBottom: gap,

        '&:last-of-type': {
          marginBottom: 0,
        },
      },
    },
    [`${EActionAttribute.UL} > ${EActionAttribute.LI}::marker`]: {
      fontWeight: fontWeight[markerFontWeight],
    },
    [`${EActionAttribute.OL} > ${EActionAttribute.LI}::marker`]: {
      fontWeight: fontWeight[markerFontWeight],
    },
  }),
);
